import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

/**
 * Transport-only entity carrying a ServiceNow field-engineer lookup row.
 * Drives the searchable dropdown in the admin backend; not persisted in Mongo.
 */
@Entity()
export class SNFieldEngineerOption extends AdornisEntity {
  static override _class = 'SNFieldEngineerOption';

  @Field(() => String)
  id: Maybe<string>;

  @Field(() => String)
  firstName: Maybe<string>;

  @Field(() => String)
  lastName: Maybe<string>;

  @Field(() => String)
  email: Maybe<string>;
}

/**
 * Transport-only entity carrying a ServiceNow client lookup row.
 */
@Entity()
export class SNClientOption extends AdornisEntity {
  static override _class = 'SNClientOption';

  @Field(() => String)
  id: Maybe<string>;

  @Field(() => String)
  name: Maybe<string>;

  @Field(() => String)
  code: Maybe<string>;

  /** The parent company's id. Empty means this client is itself a parent (top-level) company. */
  @Field(() => String)
  parentCompanyId: Maybe<string>;

  @Field(() => String)
  parentCompany: Maybe<string>;
}
